import { generatePathname } from '@/helpers/generatePathname';
import { PATH_NAME } from 'configs/pathName';
import dynamic from 'next/dynamic';
import { forwardRef } from 'react';
import { TDoccenLibraryDocumentFile } from './type';

const DocumentFileGridViewType1 = dynamic(
  () => import('./variants/DocumentFileGridViewType1')
);

const DocumentFile = forwardRef<HTMLAnchorElement, TDoccenLibraryDocumentFile>(
  (props: TDoccenLibraryDocumentFile, ref) => {
    const hashVariants = {
      [`false_1`]: <></>,
      [`true_1`]: <DocumentFileGridViewType1 {...props} />,
      [`false_2`]: <></>,
      [`true_2`]: <></>, //havent had yet
    };

    return (
      <a
        ref={ref}
        href={generatePathname({
          pathname: PATH_NAME.LIBRARY_DOCUMENT_DETAIL,
          query: {
            did: props.documentId,
          },
        })}
        className={`${props.className} block`}
      >
        {hashVariants[`${props.gridView}_${props.type}`]}
      </a>
    );
  }
);

export default DocumentFile;
